export const LOGS_DATA_RESTORE_EXPORT_VALUES = [
  {
    id: 1,
    sub_text:
      'Request the export of logs for a specified time period.  Log Exports are suitable for logs outside your contracted Hot storage retention or if you need logs but do not want them replayed in your live repository.  Please note that Data Exports may incur a fee based on your subscription, the chosen method of export and export size.  The default method is via S3.  Our team will confirm the details and cost with you after submission.',
    text: 'Logs Export'
  },
  {
    id: 2,
    sub_text:
      "Request the restoration of logs from a specified time period to your Log Repo.  Restored logs will be replayed to your live repository.  Note: Log restoration dates can not exceed your contracted Hot storage period and are limited to one request per quarter.  If you're unsure about your data retention period, our team will verify the dates and provide guidance.",
    text: 'Logs Restore'
  }
];

export default LOGS_DATA_RESTORE_EXPORT_VALUES;
